import { mapValues } from "lodash";
import { utcDate } from "~utils/Date.ts";

export function processFilterModel(model: Record<string, any>): Record<string, any> {
	return mapValues(model, (filter) => {
		if (filter.dateFrom == "$today") {
			return {
				...filter,
				dateFrom: utcDate().format("YYYY-MM-DD") + "T00:00:00",
			};
		}

		return filter;
	});
}
